/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../src/routes/__root'
import { Route as IndexRouteImport } from './../src/routes/index'
import { Route as ClusterIdSplatRouteImport } from './../src/routes/$clusterId/$'
import { Route as ClusterIdScopeIdRouteRouteImport } from './../src/routes/$clusterId/$scopeId/route'
import { Route as AuthLoginRouteImport } from './../src/routes/auth/login'
import { Route as ClusterIdScopeIdSplatRouteImport } from './../src/routes/$clusterId/$scopeId/$'
import { Route as ClusterIdScopeIdFabricRouteImport } from './../src/routes/$clusterId/$scopeId/fabric'
import { Route as ClusterIdScopeIdHomeRouteImport } from './../src/routes/$clusterId/$scopeId/home'
import { Route as ClusterIdScopeIdSettingsRouteImport } from './../src/routes/$clusterId/$scopeId/settings'
import { Route as ClusterIdScopeIdVantageRouteImport } from './../src/routes/$clusterId/$scopeId/vantage'
import { Route as AuthHandoffIndexRouteImport } from './../src/routes/auth/handoff.index'
import { Route as AuthHandoffTokenRouteImport } from './../src/routes/auth/handoff.$token'
import { Route as ClusterIdScopeIdFabricDataModelRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.data-model'
import { Route as ClusterIdScopeIdFabricExtractorsRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.extractors'
import { Route as ClusterIdScopeIdFabricLifecycleRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.lifecycle'
import { Route as ClusterIdScopeIdFabricOverviewRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.overview'
import { Route as ClusterIdScopeIdFabricSearchRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.search'
import { Route as ClusterIdScopeIdFabricSourcesRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.sources'
import { Route as ClusterIdScopeIdFabricStorageRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.storage'
import { Route as ClusterIdScopeIdFabricStreamsRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.streams'
import { Route as ClusterIdScopeIdSettingsIndexRouteImport } from './../src/routes/$clusterId/$scopeId/settings.index'
import { Route as ClusterIdScopeIdSettingsSplatRouteImport } from './../src/routes/$clusterId/$scopeId/settings.$'
import { Route as ClusterIdScopeIdSettingsIntegrationsRouteImport } from './../src/routes/$clusterId/$scopeId/settings.integrations'
import { Route as ClusterIdScopeIdSettingsOrganizationsRouteImport } from './../src/routes/$clusterId/$scopeId/settings.organizations'
import { Route as ClusterIdScopeIdSettingsTenantsRouteImport } from './../src/routes/$clusterId/$scopeId/settings.tenants'
import { Route as ClusterIdScopeIdSettingsTokensRouteImport } from './../src/routes/$clusterId/$scopeId/settings.tokens'
import { Route as ClusterIdScopeIdSettingsUsersRouteImport } from './../src/routes/$clusterId/$scopeId/settings.users'
import { Route as ClusterIdScopeIdSettingsVantageRouteImport } from './../src/routes/$clusterId/$scopeId/settings.vantage'
import { Route as ClusterIdScopeIdVantageCasesRouteImport } from './../src/routes/$clusterId/$scopeId/vantage.cases'
import { Route as ClusterIdScopeIdVantageCoverageRouteImport } from './../src/routes/$clusterId/$scopeId/vantage.coverage'
import { Route as ClusterIdScopeIdVantageDetectionsRouteImport } from './../src/routes/$clusterId/$scopeId/vantage.detections'
import { Route as ClusterIdScopeIdVantageOverviewRouteImport } from './../src/routes/$clusterId/$scopeId/vantage.overview'
import { Route as ClusterIdScopeIdVantageSignalsRouteImport } from './../src/routes/$clusterId/$scopeId/vantage.signals'
import { Route as ClusterIdScopeIdFabricExtractorsExtractorIdRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.extractors_.$extractorId'
import { Route as ClusterIdScopeIdFabricExtractorsNewRouteImport } from './../src/routes/$clusterId/$scopeId/fabric.extractors_.new'
import { Route as ClusterIdScopeIdSettingsIntegrationsIndexRouteImport } from './../src/routes/$clusterId/$scopeId/settings.integrations.index'
import { Route as ClusterIdScopeIdSettingsIntegrationsGovernanceRouteImport } from './../src/routes/$clusterId/$scopeId/settings.integrations.governance'
import { Route as ClusterIdScopeIdSettingsIntegrationsInstancesRouteImport } from './../src/routes/$clusterId/$scopeId/settings.integrations.instances'
import { Route as ClusterIdScopeIdSettingsIntegrationsPluginsRouteImport } from './../src/routes/$clusterId/$scopeId/settings.integrations.plugins'
import { Route as ClusterIdScopeIdSettingsOrganizationsOrgIdRouteImport } from './../src/routes/$clusterId/$scopeId/settings.organizations_.$orgId'
import { Route as ClusterIdScopeIdSettingsTenantsTenantIdRouteImport } from './../src/routes/$clusterId/$scopeId/settings.tenants_.$tenantId'
import { Route as ClusterIdScopeIdSettingsVantageIndexRouteImport } from './../src/routes/$clusterId/$scopeId/settings.vantage.index'
import { Route as ClusterIdScopeIdSettingsVantageCasesRouteImport } from './../src/routes/$clusterId/$scopeId/settings.vantage.cases'
import { Route as ClusterIdScopeIdVantageCasesCaseIdRouteImport } from './../src/routes/$clusterId/$scopeId/vantage.cases_.$caseId'
import { Route as ClusterIdScopeIdVantageDetectionsWorkbookRouteImport } from './../src/routes/$clusterId/$scopeId/vantage.detections_.workbook'
import { Route as ClusterIdScopeIdSettingsIntegrationsCatalogIndexRouteImport } from './../src/routes/$clusterId/$scopeId/settings.integrations.catalog.index'
import { Route as ClusterIdScopeIdSettingsIntegrationsCatalogNameRouteImport } from './../src/routes/$clusterId/$scopeId/settings.integrations.catalog.$name'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClusterIdSplatRoute = ClusterIdSplatRouteImport.update({
  id: '/$clusterId/$',
  path: '/$clusterId/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ClusterIdScopeIdRouteRoute = ClusterIdScopeIdRouteRouteImport.update({
  id: '/$clusterId/$scopeId',
  path: '/$clusterId/$scopeId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ClusterIdScopeIdSplatRoute = ClusterIdScopeIdSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => ClusterIdScopeIdRouteRoute,
} as any)
const ClusterIdScopeIdFabricRoute = ClusterIdScopeIdFabricRouteImport.update({
  id: '/fabric',
  path: '/fabric',
  getParentRoute: () => ClusterIdScopeIdRouteRoute,
} as any)
const ClusterIdScopeIdHomeRoute = ClusterIdScopeIdHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ClusterIdScopeIdRouteRoute,
} as any)
const ClusterIdScopeIdSettingsRoute =
  ClusterIdScopeIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ClusterIdScopeIdRouteRoute,
  } as any)
const ClusterIdScopeIdVantageRoute = ClusterIdScopeIdVantageRouteImport.update({
  id: '/vantage',
  path: '/vantage',
  getParentRoute: () => ClusterIdScopeIdRouteRoute,
} as any)
const AuthHandoffIndexRoute = AuthHandoffIndexRouteImport.update({
  id: '/auth/handoff/',
  path: '/auth/handoff/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthHandoffTokenRoute = AuthHandoffTokenRouteImport.update({
  id: '/auth/handoff/$token',
  path: '/auth/handoff/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ClusterIdScopeIdFabricDataModelRoute =
  ClusterIdScopeIdFabricDataModelRouteImport.update({
    id: '/data-model',
    path: '/data-model',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdFabricExtractorsRoute =
  ClusterIdScopeIdFabricExtractorsRouteImport.update({
    id: '/extractors',
    path: '/extractors',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdFabricLifecycleRoute =
  ClusterIdScopeIdFabricLifecycleRouteImport.update({
    id: '/lifecycle',
    path: '/lifecycle',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdFabricOverviewRoute =
  ClusterIdScopeIdFabricOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdFabricSearchRoute =
  ClusterIdScopeIdFabricSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdFabricSourcesRoute =
  ClusterIdScopeIdFabricSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdFabricStorageRoute =
  ClusterIdScopeIdFabricStorageRouteImport.update({
    id: '/storage',
    path: '/storage',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdFabricStreamsRoute =
  ClusterIdScopeIdFabricStreamsRouteImport.update({
    id: '/streams',
    path: '/streams',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdSettingsIndexRoute =
  ClusterIdScopeIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsSplatRoute =
  ClusterIdScopeIdSettingsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsIntegrationsRoute =
  ClusterIdScopeIdSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsOrganizationsRoute =
  ClusterIdScopeIdSettingsOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsTenantsRoute =
  ClusterIdScopeIdSettingsTenantsRouteImport.update({
    id: '/tenants',
    path: '/tenants',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsTokensRoute =
  ClusterIdScopeIdSettingsTokensRouteImport.update({
    id: '/tokens',
    path: '/tokens',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsUsersRoute =
  ClusterIdScopeIdSettingsUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsVantageRoute =
  ClusterIdScopeIdSettingsVantageRouteImport.update({
    id: '/vantage',
    path: '/vantage',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdVantageCasesRoute =
  ClusterIdScopeIdVantageCasesRouteImport.update({
    id: '/cases',
    path: '/cases',
    getParentRoute: () => ClusterIdScopeIdVantageRoute,
  } as any)
const ClusterIdScopeIdVantageCoverageRoute =
  ClusterIdScopeIdVantageCoverageRouteImport.update({
    id: '/coverage',
    path: '/coverage',
    getParentRoute: () => ClusterIdScopeIdVantageRoute,
  } as any)
const ClusterIdScopeIdVantageDetectionsRoute =
  ClusterIdScopeIdVantageDetectionsRouteImport.update({
    id: '/detections',
    path: '/detections',
    getParentRoute: () => ClusterIdScopeIdVantageRoute,
  } as any)
const ClusterIdScopeIdVantageOverviewRoute =
  ClusterIdScopeIdVantageOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ClusterIdScopeIdVantageRoute,
  } as any)
const ClusterIdScopeIdVantageSignalsRoute =
  ClusterIdScopeIdVantageSignalsRouteImport.update({
    id: '/signals',
    path: '/signals',
    getParentRoute: () => ClusterIdScopeIdVantageRoute,
  } as any)
const ClusterIdScopeIdFabricExtractorsExtractorIdRoute =
  ClusterIdScopeIdFabricExtractorsExtractorIdRouteImport.update({
    id: '/extractors_/$extractorId',
    path: '/extractors/$extractorId',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdFabricExtractorsNewRoute =
  ClusterIdScopeIdFabricExtractorsNewRouteImport.update({
    id: '/extractors_/new',
    path: '/extractors/new',
    getParentRoute: () => ClusterIdScopeIdFabricRoute,
  } as any)
const ClusterIdScopeIdSettingsIntegrationsIndexRoute =
  ClusterIdScopeIdSettingsIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClusterIdScopeIdSettingsIntegrationsRoute,
  } as any)
const ClusterIdScopeIdSettingsIntegrationsGovernanceRoute =
  ClusterIdScopeIdSettingsIntegrationsGovernanceRouteImport.update({
    id: '/governance',
    path: '/governance',
    getParentRoute: () => ClusterIdScopeIdSettingsIntegrationsRoute,
  } as any)
const ClusterIdScopeIdSettingsIntegrationsInstancesRoute =
  ClusterIdScopeIdSettingsIntegrationsInstancesRouteImport.update({
    id: '/instances',
    path: '/instances',
    getParentRoute: () => ClusterIdScopeIdSettingsIntegrationsRoute,
  } as any)
const ClusterIdScopeIdSettingsIntegrationsPluginsRoute =
  ClusterIdScopeIdSettingsIntegrationsPluginsRouteImport.update({
    id: '/plugins',
    path: '/plugins',
    getParentRoute: () => ClusterIdScopeIdSettingsIntegrationsRoute,
  } as any)
const ClusterIdScopeIdSettingsOrganizationsOrgIdRoute =
  ClusterIdScopeIdSettingsOrganizationsOrgIdRouteImport.update({
    id: '/organizations_/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsTenantsTenantIdRoute =
  ClusterIdScopeIdSettingsTenantsTenantIdRouteImport.update({
    id: '/tenants_/$tenantId',
    path: '/tenants/$tenantId',
    getParentRoute: () => ClusterIdScopeIdSettingsRoute,
  } as any)
const ClusterIdScopeIdSettingsVantageIndexRoute =
  ClusterIdScopeIdSettingsVantageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ClusterIdScopeIdSettingsVantageRoute,
  } as any)
const ClusterIdScopeIdSettingsVantageCasesRoute =
  ClusterIdScopeIdSettingsVantageCasesRouteImport.update({
    id: '/cases',
    path: '/cases',
    getParentRoute: () => ClusterIdScopeIdSettingsVantageRoute,
  } as any)
const ClusterIdScopeIdVantageCasesCaseIdRoute =
  ClusterIdScopeIdVantageCasesCaseIdRouteImport.update({
    id: '/cases_/$caseId',
    path: '/cases/$caseId',
    getParentRoute: () => ClusterIdScopeIdVantageRoute,
  } as any)
const ClusterIdScopeIdVantageDetectionsWorkbookRoute =
  ClusterIdScopeIdVantageDetectionsWorkbookRouteImport.update({
    id: '/detections_/workbook',
    path: '/detections/workbook',
    getParentRoute: () => ClusterIdScopeIdVantageRoute,
  } as any)
const ClusterIdScopeIdSettingsIntegrationsCatalogIndexRoute =
  ClusterIdScopeIdSettingsIntegrationsCatalogIndexRouteImport.update({
    id: '/catalog/',
    path: '/catalog/',
    getParentRoute: () => ClusterIdScopeIdSettingsIntegrationsRoute,
  } as any)
const ClusterIdScopeIdSettingsIntegrationsCatalogNameRoute =
  ClusterIdScopeIdSettingsIntegrationsCatalogNameRouteImport.update({
    id: '/catalog/$name',
    path: '/catalog/$name',
    getParentRoute: () => ClusterIdScopeIdSettingsIntegrationsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$clusterId/$scopeId': typeof ClusterIdScopeIdRouteRouteWithChildren
  '/$clusterId/$': typeof ClusterIdSplatRoute
  '/auth/login': typeof AuthLoginRoute
  '/$clusterId/$scopeId/$': typeof ClusterIdScopeIdSplatRoute
  '/$clusterId/$scopeId/fabric': typeof ClusterIdScopeIdFabricRouteWithChildren
  '/$clusterId/$scopeId/home': typeof ClusterIdScopeIdHomeRoute
  '/$clusterId/$scopeId/settings': typeof ClusterIdScopeIdSettingsRouteWithChildren
  '/$clusterId/$scopeId/vantage': typeof ClusterIdScopeIdVantageRouteWithChildren
  '/auth/handoff/$token': typeof AuthHandoffTokenRoute
  '/auth/handoff/': typeof AuthHandoffIndexRoute
  '/$clusterId/$scopeId/fabric/data-model': typeof ClusterIdScopeIdFabricDataModelRoute
  '/$clusterId/$scopeId/fabric/extractors': typeof ClusterIdScopeIdFabricExtractorsRoute
  '/$clusterId/$scopeId/fabric/lifecycle': typeof ClusterIdScopeIdFabricLifecycleRoute
  '/$clusterId/$scopeId/fabric/overview': typeof ClusterIdScopeIdFabricOverviewRoute
  '/$clusterId/$scopeId/fabric/search': typeof ClusterIdScopeIdFabricSearchRoute
  '/$clusterId/$scopeId/fabric/sources': typeof ClusterIdScopeIdFabricSourcesRoute
  '/$clusterId/$scopeId/fabric/storage': typeof ClusterIdScopeIdFabricStorageRoute
  '/$clusterId/$scopeId/fabric/streams': typeof ClusterIdScopeIdFabricStreamsRoute
  '/$clusterId/$scopeId/settings/$': typeof ClusterIdScopeIdSettingsSplatRoute
  '/$clusterId/$scopeId/settings/integrations': typeof ClusterIdScopeIdSettingsIntegrationsRouteWithChildren
  '/$clusterId/$scopeId/settings/organizations': typeof ClusterIdScopeIdSettingsOrganizationsRoute
  '/$clusterId/$scopeId/settings/tenants': typeof ClusterIdScopeIdSettingsTenantsRoute
  '/$clusterId/$scopeId/settings/tokens': typeof ClusterIdScopeIdSettingsTokensRoute
  '/$clusterId/$scopeId/settings/users': typeof ClusterIdScopeIdSettingsUsersRoute
  '/$clusterId/$scopeId/settings/vantage': typeof ClusterIdScopeIdSettingsVantageRouteWithChildren
  '/$clusterId/$scopeId/vantage/cases': typeof ClusterIdScopeIdVantageCasesRoute
  '/$clusterId/$scopeId/vantage/coverage': typeof ClusterIdScopeIdVantageCoverageRoute
  '/$clusterId/$scopeId/vantage/detections': typeof ClusterIdScopeIdVantageDetectionsRoute
  '/$clusterId/$scopeId/vantage/overview': typeof ClusterIdScopeIdVantageOverviewRoute
  '/$clusterId/$scopeId/vantage/signals': typeof ClusterIdScopeIdVantageSignalsRoute
  '/$clusterId/$scopeId/settings/': typeof ClusterIdScopeIdSettingsIndexRoute
  '/$clusterId/$scopeId/fabric/extractors/$extractorId': typeof ClusterIdScopeIdFabricExtractorsExtractorIdRoute
  '/$clusterId/$scopeId/fabric/extractors/new': typeof ClusterIdScopeIdFabricExtractorsNewRoute
  '/$clusterId/$scopeId/settings/integrations/governance': typeof ClusterIdScopeIdSettingsIntegrationsGovernanceRoute
  '/$clusterId/$scopeId/settings/integrations/instances': typeof ClusterIdScopeIdSettingsIntegrationsInstancesRoute
  '/$clusterId/$scopeId/settings/integrations/plugins': typeof ClusterIdScopeIdSettingsIntegrationsPluginsRoute
  '/$clusterId/$scopeId/settings/organizations/$orgId': typeof ClusterIdScopeIdSettingsOrganizationsOrgIdRoute
  '/$clusterId/$scopeId/settings/tenants/$tenantId': typeof ClusterIdScopeIdSettingsTenantsTenantIdRoute
  '/$clusterId/$scopeId/settings/vantage/cases': typeof ClusterIdScopeIdSettingsVantageCasesRoute
  '/$clusterId/$scopeId/vantage/cases/$caseId': typeof ClusterIdScopeIdVantageCasesCaseIdRoute
  '/$clusterId/$scopeId/vantage/detections/workbook': typeof ClusterIdScopeIdVantageDetectionsWorkbookRoute
  '/$clusterId/$scopeId/settings/integrations/': typeof ClusterIdScopeIdSettingsIntegrationsIndexRoute
  '/$clusterId/$scopeId/settings/vantage/': typeof ClusterIdScopeIdSettingsVantageIndexRoute
  '/$clusterId/$scopeId/settings/integrations/catalog/$name': typeof ClusterIdScopeIdSettingsIntegrationsCatalogNameRoute
  '/$clusterId/$scopeId/settings/integrations/catalog/': typeof ClusterIdScopeIdSettingsIntegrationsCatalogIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$clusterId/$scopeId': typeof ClusterIdScopeIdRouteRouteWithChildren
  '/$clusterId/$': typeof ClusterIdSplatRoute
  '/auth/login': typeof AuthLoginRoute
  '/$clusterId/$scopeId/$': typeof ClusterIdScopeIdSplatRoute
  '/$clusterId/$scopeId/fabric': typeof ClusterIdScopeIdFabricRouteWithChildren
  '/$clusterId/$scopeId/home': typeof ClusterIdScopeIdHomeRoute
  '/$clusterId/$scopeId/vantage': typeof ClusterIdScopeIdVantageRouteWithChildren
  '/auth/handoff/$token': typeof AuthHandoffTokenRoute
  '/auth/handoff': typeof AuthHandoffIndexRoute
  '/$clusterId/$scopeId/fabric/data-model': typeof ClusterIdScopeIdFabricDataModelRoute
  '/$clusterId/$scopeId/fabric/extractors': typeof ClusterIdScopeIdFabricExtractorsRoute
  '/$clusterId/$scopeId/fabric/lifecycle': typeof ClusterIdScopeIdFabricLifecycleRoute
  '/$clusterId/$scopeId/fabric/overview': typeof ClusterIdScopeIdFabricOverviewRoute
  '/$clusterId/$scopeId/fabric/search': typeof ClusterIdScopeIdFabricSearchRoute
  '/$clusterId/$scopeId/fabric/sources': typeof ClusterIdScopeIdFabricSourcesRoute
  '/$clusterId/$scopeId/fabric/storage': typeof ClusterIdScopeIdFabricStorageRoute
  '/$clusterId/$scopeId/fabric/streams': typeof ClusterIdScopeIdFabricStreamsRoute
  '/$clusterId/$scopeId/settings/$': typeof ClusterIdScopeIdSettingsSplatRoute
  '/$clusterId/$scopeId/settings/organizations': typeof ClusterIdScopeIdSettingsOrganizationsRoute
  '/$clusterId/$scopeId/settings/tenants': typeof ClusterIdScopeIdSettingsTenantsRoute
  '/$clusterId/$scopeId/settings/tokens': typeof ClusterIdScopeIdSettingsTokensRoute
  '/$clusterId/$scopeId/settings/users': typeof ClusterIdScopeIdSettingsUsersRoute
  '/$clusterId/$scopeId/vantage/cases': typeof ClusterIdScopeIdVantageCasesRoute
  '/$clusterId/$scopeId/vantage/coverage': typeof ClusterIdScopeIdVantageCoverageRoute
  '/$clusterId/$scopeId/vantage/detections': typeof ClusterIdScopeIdVantageDetectionsRoute
  '/$clusterId/$scopeId/vantage/overview': typeof ClusterIdScopeIdVantageOverviewRoute
  '/$clusterId/$scopeId/vantage/signals': typeof ClusterIdScopeIdVantageSignalsRoute
  '/$clusterId/$scopeId/settings': typeof ClusterIdScopeIdSettingsIndexRoute
  '/$clusterId/$scopeId/fabric/extractors/$extractorId': typeof ClusterIdScopeIdFabricExtractorsExtractorIdRoute
  '/$clusterId/$scopeId/fabric/extractors/new': typeof ClusterIdScopeIdFabricExtractorsNewRoute
  '/$clusterId/$scopeId/settings/integrations/governance': typeof ClusterIdScopeIdSettingsIntegrationsGovernanceRoute
  '/$clusterId/$scopeId/settings/integrations/instances': typeof ClusterIdScopeIdSettingsIntegrationsInstancesRoute
  '/$clusterId/$scopeId/settings/integrations/plugins': typeof ClusterIdScopeIdSettingsIntegrationsPluginsRoute
  '/$clusterId/$scopeId/settings/organizations/$orgId': typeof ClusterIdScopeIdSettingsOrganizationsOrgIdRoute
  '/$clusterId/$scopeId/settings/tenants/$tenantId': typeof ClusterIdScopeIdSettingsTenantsTenantIdRoute
  '/$clusterId/$scopeId/settings/vantage/cases': typeof ClusterIdScopeIdSettingsVantageCasesRoute
  '/$clusterId/$scopeId/vantage/cases/$caseId': typeof ClusterIdScopeIdVantageCasesCaseIdRoute
  '/$clusterId/$scopeId/vantage/detections/workbook': typeof ClusterIdScopeIdVantageDetectionsWorkbookRoute
  '/$clusterId/$scopeId/settings/integrations': typeof ClusterIdScopeIdSettingsIntegrationsIndexRoute
  '/$clusterId/$scopeId/settings/vantage': typeof ClusterIdScopeIdSettingsVantageIndexRoute
  '/$clusterId/$scopeId/settings/integrations/catalog/$name': typeof ClusterIdScopeIdSettingsIntegrationsCatalogNameRoute
  '/$clusterId/$scopeId/settings/integrations/catalog': typeof ClusterIdScopeIdSettingsIntegrationsCatalogIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$clusterId/$scopeId': typeof ClusterIdScopeIdRouteRouteWithChildren
  '/$clusterId/$': typeof ClusterIdSplatRoute
  '/auth/login': typeof AuthLoginRoute
  '/$clusterId/$scopeId/$': typeof ClusterIdScopeIdSplatRoute
  '/$clusterId/$scopeId/fabric': typeof ClusterIdScopeIdFabricRouteWithChildren
  '/$clusterId/$scopeId/home': typeof ClusterIdScopeIdHomeRoute
  '/$clusterId/$scopeId/settings': typeof ClusterIdScopeIdSettingsRouteWithChildren
  '/$clusterId/$scopeId/vantage': typeof ClusterIdScopeIdVantageRouteWithChildren
  '/auth/handoff/$token': typeof AuthHandoffTokenRoute
  '/auth/handoff/': typeof AuthHandoffIndexRoute
  '/$clusterId/$scopeId/fabric/data-model': typeof ClusterIdScopeIdFabricDataModelRoute
  '/$clusterId/$scopeId/fabric/extractors': typeof ClusterIdScopeIdFabricExtractorsRoute
  '/$clusterId/$scopeId/fabric/lifecycle': typeof ClusterIdScopeIdFabricLifecycleRoute
  '/$clusterId/$scopeId/fabric/overview': typeof ClusterIdScopeIdFabricOverviewRoute
  '/$clusterId/$scopeId/fabric/search': typeof ClusterIdScopeIdFabricSearchRoute
  '/$clusterId/$scopeId/fabric/sources': typeof ClusterIdScopeIdFabricSourcesRoute
  '/$clusterId/$scopeId/fabric/storage': typeof ClusterIdScopeIdFabricStorageRoute
  '/$clusterId/$scopeId/fabric/streams': typeof ClusterIdScopeIdFabricStreamsRoute
  '/$clusterId/$scopeId/settings/$': typeof ClusterIdScopeIdSettingsSplatRoute
  '/$clusterId/$scopeId/settings/integrations': typeof ClusterIdScopeIdSettingsIntegrationsRouteWithChildren
  '/$clusterId/$scopeId/settings/organizations': typeof ClusterIdScopeIdSettingsOrganizationsRoute
  '/$clusterId/$scopeId/settings/tenants': typeof ClusterIdScopeIdSettingsTenantsRoute
  '/$clusterId/$scopeId/settings/tokens': typeof ClusterIdScopeIdSettingsTokensRoute
  '/$clusterId/$scopeId/settings/users': typeof ClusterIdScopeIdSettingsUsersRoute
  '/$clusterId/$scopeId/settings/vantage': typeof ClusterIdScopeIdSettingsVantageRouteWithChildren
  '/$clusterId/$scopeId/vantage/cases': typeof ClusterIdScopeIdVantageCasesRoute
  '/$clusterId/$scopeId/vantage/coverage': typeof ClusterIdScopeIdVantageCoverageRoute
  '/$clusterId/$scopeId/vantage/detections': typeof ClusterIdScopeIdVantageDetectionsRoute
  '/$clusterId/$scopeId/vantage/overview': typeof ClusterIdScopeIdVantageOverviewRoute
  '/$clusterId/$scopeId/vantage/signals': typeof ClusterIdScopeIdVantageSignalsRoute
  '/$clusterId/$scopeId/settings/': typeof ClusterIdScopeIdSettingsIndexRoute
  '/$clusterId/$scopeId/fabric/extractors_/$extractorId': typeof ClusterIdScopeIdFabricExtractorsExtractorIdRoute
  '/$clusterId/$scopeId/fabric/extractors_/new': typeof ClusterIdScopeIdFabricExtractorsNewRoute
  '/$clusterId/$scopeId/settings/integrations/governance': typeof ClusterIdScopeIdSettingsIntegrationsGovernanceRoute
  '/$clusterId/$scopeId/settings/integrations/instances': typeof ClusterIdScopeIdSettingsIntegrationsInstancesRoute
  '/$clusterId/$scopeId/settings/integrations/plugins': typeof ClusterIdScopeIdSettingsIntegrationsPluginsRoute
  '/$clusterId/$scopeId/settings/organizations_/$orgId': typeof ClusterIdScopeIdSettingsOrganizationsOrgIdRoute
  '/$clusterId/$scopeId/settings/tenants_/$tenantId': typeof ClusterIdScopeIdSettingsTenantsTenantIdRoute
  '/$clusterId/$scopeId/settings/vantage/cases': typeof ClusterIdScopeIdSettingsVantageCasesRoute
  '/$clusterId/$scopeId/vantage/cases_/$caseId': typeof ClusterIdScopeIdVantageCasesCaseIdRoute
  '/$clusterId/$scopeId/vantage/detections_/workbook': typeof ClusterIdScopeIdVantageDetectionsWorkbookRoute
  '/$clusterId/$scopeId/settings/integrations/': typeof ClusterIdScopeIdSettingsIntegrationsIndexRoute
  '/$clusterId/$scopeId/settings/vantage/': typeof ClusterIdScopeIdSettingsVantageIndexRoute
  '/$clusterId/$scopeId/settings/integrations/catalog/$name': typeof ClusterIdScopeIdSettingsIntegrationsCatalogNameRoute
  '/$clusterId/$scopeId/settings/integrations/catalog/': typeof ClusterIdScopeIdSettingsIntegrationsCatalogIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$clusterId/$scopeId'
    | '/$clusterId/$'
    | '/auth/login'
    | '/$clusterId/$scopeId/$'
    | '/$clusterId/$scopeId/fabric'
    | '/$clusterId/$scopeId/home'
    | '/$clusterId/$scopeId/settings'
    | '/$clusterId/$scopeId/vantage'
    | '/auth/handoff/$token'
    | '/auth/handoff/'
    | '/$clusterId/$scopeId/fabric/data-model'
    | '/$clusterId/$scopeId/fabric/extractors'
    | '/$clusterId/$scopeId/fabric/lifecycle'
    | '/$clusterId/$scopeId/fabric/overview'
    | '/$clusterId/$scopeId/fabric/search'
    | '/$clusterId/$scopeId/fabric/sources'
    | '/$clusterId/$scopeId/fabric/storage'
    | '/$clusterId/$scopeId/fabric/streams'
    | '/$clusterId/$scopeId/settings/$'
    | '/$clusterId/$scopeId/settings/integrations'
    | '/$clusterId/$scopeId/settings/organizations'
    | '/$clusterId/$scopeId/settings/tenants'
    | '/$clusterId/$scopeId/settings/tokens'
    | '/$clusterId/$scopeId/settings/users'
    | '/$clusterId/$scopeId/settings/vantage'
    | '/$clusterId/$scopeId/vantage/cases'
    | '/$clusterId/$scopeId/vantage/coverage'
    | '/$clusterId/$scopeId/vantage/detections'
    | '/$clusterId/$scopeId/vantage/overview'
    | '/$clusterId/$scopeId/vantage/signals'
    | '/$clusterId/$scopeId/settings/'
    | '/$clusterId/$scopeId/fabric/extractors/$extractorId'
    | '/$clusterId/$scopeId/fabric/extractors/new'
    | '/$clusterId/$scopeId/settings/integrations/governance'
    | '/$clusterId/$scopeId/settings/integrations/instances'
    | '/$clusterId/$scopeId/settings/integrations/plugins'
    | '/$clusterId/$scopeId/settings/organizations/$orgId'
    | '/$clusterId/$scopeId/settings/tenants/$tenantId'
    | '/$clusterId/$scopeId/settings/vantage/cases'
    | '/$clusterId/$scopeId/vantage/cases/$caseId'
    | '/$clusterId/$scopeId/vantage/detections/workbook'
    | '/$clusterId/$scopeId/settings/integrations/'
    | '/$clusterId/$scopeId/settings/vantage/'
    | '/$clusterId/$scopeId/settings/integrations/catalog/$name'
    | '/$clusterId/$scopeId/settings/integrations/catalog/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$clusterId/$scopeId'
    | '/$clusterId/$'
    | '/auth/login'
    | '/$clusterId/$scopeId/$'
    | '/$clusterId/$scopeId/fabric'
    | '/$clusterId/$scopeId/home'
    | '/$clusterId/$scopeId/vantage'
    | '/auth/handoff/$token'
    | '/auth/handoff'
    | '/$clusterId/$scopeId/fabric/data-model'
    | '/$clusterId/$scopeId/fabric/extractors'
    | '/$clusterId/$scopeId/fabric/lifecycle'
    | '/$clusterId/$scopeId/fabric/overview'
    | '/$clusterId/$scopeId/fabric/search'
    | '/$clusterId/$scopeId/fabric/sources'
    | '/$clusterId/$scopeId/fabric/storage'
    | '/$clusterId/$scopeId/fabric/streams'
    | '/$clusterId/$scopeId/settings/$'
    | '/$clusterId/$scopeId/settings/organizations'
    | '/$clusterId/$scopeId/settings/tenants'
    | '/$clusterId/$scopeId/settings/tokens'
    | '/$clusterId/$scopeId/settings/users'
    | '/$clusterId/$scopeId/vantage/cases'
    | '/$clusterId/$scopeId/vantage/coverage'
    | '/$clusterId/$scopeId/vantage/detections'
    | '/$clusterId/$scopeId/vantage/overview'
    | '/$clusterId/$scopeId/vantage/signals'
    | '/$clusterId/$scopeId/settings'
    | '/$clusterId/$scopeId/fabric/extractors/$extractorId'
    | '/$clusterId/$scopeId/fabric/extractors/new'
    | '/$clusterId/$scopeId/settings/integrations/governance'
    | '/$clusterId/$scopeId/settings/integrations/instances'
    | '/$clusterId/$scopeId/settings/integrations/plugins'
    | '/$clusterId/$scopeId/settings/organizations/$orgId'
    | '/$clusterId/$scopeId/settings/tenants/$tenantId'
    | '/$clusterId/$scopeId/settings/vantage/cases'
    | '/$clusterId/$scopeId/vantage/cases/$caseId'
    | '/$clusterId/$scopeId/vantage/detections/workbook'
    | '/$clusterId/$scopeId/settings/integrations'
    | '/$clusterId/$scopeId/settings/vantage'
    | '/$clusterId/$scopeId/settings/integrations/catalog/$name'
    | '/$clusterId/$scopeId/settings/integrations/catalog'
  id:
    | '__root__'
    | '/'
    | '/$clusterId/$scopeId'
    | '/$clusterId/$'
    | '/auth/login'
    | '/$clusterId/$scopeId/$'
    | '/$clusterId/$scopeId/fabric'
    | '/$clusterId/$scopeId/home'
    | '/$clusterId/$scopeId/settings'
    | '/$clusterId/$scopeId/vantage'
    | '/auth/handoff/$token'
    | '/auth/handoff/'
    | '/$clusterId/$scopeId/fabric/data-model'
    | '/$clusterId/$scopeId/fabric/extractors'
    | '/$clusterId/$scopeId/fabric/lifecycle'
    | '/$clusterId/$scopeId/fabric/overview'
    | '/$clusterId/$scopeId/fabric/search'
    | '/$clusterId/$scopeId/fabric/sources'
    | '/$clusterId/$scopeId/fabric/storage'
    | '/$clusterId/$scopeId/fabric/streams'
    | '/$clusterId/$scopeId/settings/$'
    | '/$clusterId/$scopeId/settings/integrations'
    | '/$clusterId/$scopeId/settings/organizations'
    | '/$clusterId/$scopeId/settings/tenants'
    | '/$clusterId/$scopeId/settings/tokens'
    | '/$clusterId/$scopeId/settings/users'
    | '/$clusterId/$scopeId/settings/vantage'
    | '/$clusterId/$scopeId/vantage/cases'
    | '/$clusterId/$scopeId/vantage/coverage'
    | '/$clusterId/$scopeId/vantage/detections'
    | '/$clusterId/$scopeId/vantage/overview'
    | '/$clusterId/$scopeId/vantage/signals'
    | '/$clusterId/$scopeId/settings/'
    | '/$clusterId/$scopeId/fabric/extractors_/$extractorId'
    | '/$clusterId/$scopeId/fabric/extractors_/new'
    | '/$clusterId/$scopeId/settings/integrations/governance'
    | '/$clusterId/$scopeId/settings/integrations/instances'
    | '/$clusterId/$scopeId/settings/integrations/plugins'
    | '/$clusterId/$scopeId/settings/organizations_/$orgId'
    | '/$clusterId/$scopeId/settings/tenants_/$tenantId'
    | '/$clusterId/$scopeId/settings/vantage/cases'
    | '/$clusterId/$scopeId/vantage/cases_/$caseId'
    | '/$clusterId/$scopeId/vantage/detections_/workbook'
    | '/$clusterId/$scopeId/settings/integrations/'
    | '/$clusterId/$scopeId/settings/vantage/'
    | '/$clusterId/$scopeId/settings/integrations/catalog/$name'
    | '/$clusterId/$scopeId/settings/integrations/catalog/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClusterIdScopeIdRouteRoute: typeof ClusterIdScopeIdRouteRouteWithChildren
  ClusterIdSplatRoute: typeof ClusterIdSplatRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthHandoffTokenRoute: typeof AuthHandoffTokenRoute
  AuthHandoffIndexRoute: typeof AuthHandoffIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$clusterId/$': {
      id: '/$clusterId/$'
      path: '/$clusterId/$'
      fullPath: '/$clusterId/$'
      preLoaderRoute: typeof ClusterIdSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$clusterId/$scopeId': {
      id: '/$clusterId/$scopeId'
      path: '/$clusterId/$scopeId'
      fullPath: '/$clusterId/$scopeId'
      preLoaderRoute: typeof ClusterIdScopeIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$clusterId/$scopeId/$': {
      id: '/$clusterId/$scopeId/$'
      path: '/$'
      fullPath: '/$clusterId/$scopeId/$'
      preLoaderRoute: typeof ClusterIdScopeIdSplatRouteImport
      parentRoute: typeof ClusterIdScopeIdRouteRoute
    }
    '/$clusterId/$scopeId/fabric': {
      id: '/$clusterId/$scopeId/fabric'
      path: '/fabric'
      fullPath: '/$clusterId/$scopeId/fabric'
      preLoaderRoute: typeof ClusterIdScopeIdFabricRouteImport
      parentRoute: typeof ClusterIdScopeIdRouteRoute
    }
    '/$clusterId/$scopeId/home': {
      id: '/$clusterId/$scopeId/home'
      path: '/home'
      fullPath: '/$clusterId/$scopeId/home'
      preLoaderRoute: typeof ClusterIdScopeIdHomeRouteImport
      parentRoute: typeof ClusterIdScopeIdRouteRoute
    }
    '/$clusterId/$scopeId/settings': {
      id: '/$clusterId/$scopeId/settings'
      path: '/settings'
      fullPath: '/$clusterId/$scopeId/settings'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsRouteImport
      parentRoute: typeof ClusterIdScopeIdRouteRoute
    }
    '/$clusterId/$scopeId/vantage': {
      id: '/$clusterId/$scopeId/vantage'
      path: '/vantage'
      fullPath: '/$clusterId/$scopeId/vantage'
      preLoaderRoute: typeof ClusterIdScopeIdVantageRouteImport
      parentRoute: typeof ClusterIdScopeIdRouteRoute
    }
    '/auth/handoff/': {
      id: '/auth/handoff/'
      path: '/auth/handoff'
      fullPath: '/auth/handoff/'
      preLoaderRoute: typeof AuthHandoffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/handoff/$token': {
      id: '/auth/handoff/$token'
      path: '/auth/handoff/$token'
      fullPath: '/auth/handoff/$token'
      preLoaderRoute: typeof AuthHandoffTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$clusterId/$scopeId/fabric/data-model': {
      id: '/$clusterId/$scopeId/fabric/data-model'
      path: '/data-model'
      fullPath: '/$clusterId/$scopeId/fabric/data-model'
      preLoaderRoute: typeof ClusterIdScopeIdFabricDataModelRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/fabric/extractors': {
      id: '/$clusterId/$scopeId/fabric/extractors'
      path: '/extractors'
      fullPath: '/$clusterId/$scopeId/fabric/extractors'
      preLoaderRoute: typeof ClusterIdScopeIdFabricExtractorsRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/fabric/lifecycle': {
      id: '/$clusterId/$scopeId/fabric/lifecycle'
      path: '/lifecycle'
      fullPath: '/$clusterId/$scopeId/fabric/lifecycle'
      preLoaderRoute: typeof ClusterIdScopeIdFabricLifecycleRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/fabric/overview': {
      id: '/$clusterId/$scopeId/fabric/overview'
      path: '/overview'
      fullPath: '/$clusterId/$scopeId/fabric/overview'
      preLoaderRoute: typeof ClusterIdScopeIdFabricOverviewRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/fabric/search': {
      id: '/$clusterId/$scopeId/fabric/search'
      path: '/search'
      fullPath: '/$clusterId/$scopeId/fabric/search'
      preLoaderRoute: typeof ClusterIdScopeIdFabricSearchRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/fabric/sources': {
      id: '/$clusterId/$scopeId/fabric/sources'
      path: '/sources'
      fullPath: '/$clusterId/$scopeId/fabric/sources'
      preLoaderRoute: typeof ClusterIdScopeIdFabricSourcesRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/fabric/storage': {
      id: '/$clusterId/$scopeId/fabric/storage'
      path: '/storage'
      fullPath: '/$clusterId/$scopeId/fabric/storage'
      preLoaderRoute: typeof ClusterIdScopeIdFabricStorageRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/fabric/streams': {
      id: '/$clusterId/$scopeId/fabric/streams'
      path: '/streams'
      fullPath: '/$clusterId/$scopeId/fabric/streams'
      preLoaderRoute: typeof ClusterIdScopeIdFabricStreamsRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/settings/': {
      id: '/$clusterId/$scopeId/settings/'
      path: '/'
      fullPath: '/$clusterId/$scopeId/settings/'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsIndexRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/$': {
      id: '/$clusterId/$scopeId/settings/$'
      path: '/$'
      fullPath: '/$clusterId/$scopeId/settings/$'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsSplatRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/integrations': {
      id: '/$clusterId/$scopeId/settings/integrations'
      path: '/integrations'
      fullPath: '/$clusterId/$scopeId/settings/integrations'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsIntegrationsRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/organizations': {
      id: '/$clusterId/$scopeId/settings/organizations'
      path: '/organizations'
      fullPath: '/$clusterId/$scopeId/settings/organizations'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsOrganizationsRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/tenants': {
      id: '/$clusterId/$scopeId/settings/tenants'
      path: '/tenants'
      fullPath: '/$clusterId/$scopeId/settings/tenants'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsTenantsRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/tokens': {
      id: '/$clusterId/$scopeId/settings/tokens'
      path: '/tokens'
      fullPath: '/$clusterId/$scopeId/settings/tokens'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsTokensRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/users': {
      id: '/$clusterId/$scopeId/settings/users'
      path: '/users'
      fullPath: '/$clusterId/$scopeId/settings/users'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsUsersRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/vantage': {
      id: '/$clusterId/$scopeId/settings/vantage'
      path: '/vantage'
      fullPath: '/$clusterId/$scopeId/settings/vantage'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsVantageRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/vantage/cases': {
      id: '/$clusterId/$scopeId/vantage/cases'
      path: '/cases'
      fullPath: '/$clusterId/$scopeId/vantage/cases'
      preLoaderRoute: typeof ClusterIdScopeIdVantageCasesRouteImport
      parentRoute: typeof ClusterIdScopeIdVantageRoute
    }
    '/$clusterId/$scopeId/vantage/coverage': {
      id: '/$clusterId/$scopeId/vantage/coverage'
      path: '/coverage'
      fullPath: '/$clusterId/$scopeId/vantage/coverage'
      preLoaderRoute: typeof ClusterIdScopeIdVantageCoverageRouteImport
      parentRoute: typeof ClusterIdScopeIdVantageRoute
    }
    '/$clusterId/$scopeId/vantage/detections': {
      id: '/$clusterId/$scopeId/vantage/detections'
      path: '/detections'
      fullPath: '/$clusterId/$scopeId/vantage/detections'
      preLoaderRoute: typeof ClusterIdScopeIdVantageDetectionsRouteImport
      parentRoute: typeof ClusterIdScopeIdVantageRoute
    }
    '/$clusterId/$scopeId/vantage/overview': {
      id: '/$clusterId/$scopeId/vantage/overview'
      path: '/overview'
      fullPath: '/$clusterId/$scopeId/vantage/overview'
      preLoaderRoute: typeof ClusterIdScopeIdVantageOverviewRouteImport
      parentRoute: typeof ClusterIdScopeIdVantageRoute
    }
    '/$clusterId/$scopeId/vantage/signals': {
      id: '/$clusterId/$scopeId/vantage/signals'
      path: '/signals'
      fullPath: '/$clusterId/$scopeId/vantage/signals'
      preLoaderRoute: typeof ClusterIdScopeIdVantageSignalsRouteImport
      parentRoute: typeof ClusterIdScopeIdVantageRoute
    }
    '/$clusterId/$scopeId/fabric/extractors_/$extractorId': {
      id: '/$clusterId/$scopeId/fabric/extractors_/$extractorId'
      path: '/extractors/$extractorId'
      fullPath: '/$clusterId/$scopeId/fabric/extractors/$extractorId'
      preLoaderRoute: typeof ClusterIdScopeIdFabricExtractorsExtractorIdRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/fabric/extractors_/new': {
      id: '/$clusterId/$scopeId/fabric/extractors_/new'
      path: '/extractors/new'
      fullPath: '/$clusterId/$scopeId/fabric/extractors/new'
      preLoaderRoute: typeof ClusterIdScopeIdFabricExtractorsNewRouteImport
      parentRoute: typeof ClusterIdScopeIdFabricRoute
    }
    '/$clusterId/$scopeId/settings/integrations/': {
      id: '/$clusterId/$scopeId/settings/integrations/'
      path: '/'
      fullPath: '/$clusterId/$scopeId/settings/integrations/'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsIntegrationsIndexRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsIntegrationsRoute
    }
    '/$clusterId/$scopeId/settings/integrations/governance': {
      id: '/$clusterId/$scopeId/settings/integrations/governance'
      path: '/governance'
      fullPath: '/$clusterId/$scopeId/settings/integrations/governance'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsIntegrationsGovernanceRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsIntegrationsRoute
    }
    '/$clusterId/$scopeId/settings/integrations/instances': {
      id: '/$clusterId/$scopeId/settings/integrations/instances'
      path: '/instances'
      fullPath: '/$clusterId/$scopeId/settings/integrations/instances'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsIntegrationsInstancesRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsIntegrationsRoute
    }
    '/$clusterId/$scopeId/settings/integrations/plugins': {
      id: '/$clusterId/$scopeId/settings/integrations/plugins'
      path: '/plugins'
      fullPath: '/$clusterId/$scopeId/settings/integrations/plugins'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsIntegrationsPluginsRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsIntegrationsRoute
    }
    '/$clusterId/$scopeId/settings/organizations_/$orgId': {
      id: '/$clusterId/$scopeId/settings/organizations_/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/$clusterId/$scopeId/settings/organizations/$orgId'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsOrganizationsOrgIdRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/tenants_/$tenantId': {
      id: '/$clusterId/$scopeId/settings/tenants_/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/$clusterId/$scopeId/settings/tenants/$tenantId'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsTenantsTenantIdRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsRoute
    }
    '/$clusterId/$scopeId/settings/vantage/': {
      id: '/$clusterId/$scopeId/settings/vantage/'
      path: '/'
      fullPath: '/$clusterId/$scopeId/settings/vantage/'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsVantageIndexRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsVantageRoute
    }
    '/$clusterId/$scopeId/settings/vantage/cases': {
      id: '/$clusterId/$scopeId/settings/vantage/cases'
      path: '/cases'
      fullPath: '/$clusterId/$scopeId/settings/vantage/cases'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsVantageCasesRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsVantageRoute
    }
    '/$clusterId/$scopeId/vantage/cases_/$caseId': {
      id: '/$clusterId/$scopeId/vantage/cases_/$caseId'
      path: '/cases/$caseId'
      fullPath: '/$clusterId/$scopeId/vantage/cases/$caseId'
      preLoaderRoute: typeof ClusterIdScopeIdVantageCasesCaseIdRouteImport
      parentRoute: typeof ClusterIdScopeIdVantageRoute
    }
    '/$clusterId/$scopeId/vantage/detections_/workbook': {
      id: '/$clusterId/$scopeId/vantage/detections_/workbook'
      path: '/detections/workbook'
      fullPath: '/$clusterId/$scopeId/vantage/detections/workbook'
      preLoaderRoute: typeof ClusterIdScopeIdVantageDetectionsWorkbookRouteImport
      parentRoute: typeof ClusterIdScopeIdVantageRoute
    }
    '/$clusterId/$scopeId/settings/integrations/catalog/': {
      id: '/$clusterId/$scopeId/settings/integrations/catalog/'
      path: '/catalog'
      fullPath: '/$clusterId/$scopeId/settings/integrations/catalog/'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsIntegrationsCatalogIndexRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsIntegrationsRoute
    }
    '/$clusterId/$scopeId/settings/integrations/catalog/$name': {
      id: '/$clusterId/$scopeId/settings/integrations/catalog/$name'
      path: '/catalog/$name'
      fullPath: '/$clusterId/$scopeId/settings/integrations/catalog/$name'
      preLoaderRoute: typeof ClusterIdScopeIdSettingsIntegrationsCatalogNameRouteImport
      parentRoute: typeof ClusterIdScopeIdSettingsIntegrationsRoute
    }
  }
}

interface ClusterIdScopeIdFabricRouteChildren {
  ClusterIdScopeIdFabricDataModelRoute: typeof ClusterIdScopeIdFabricDataModelRoute
  ClusterIdScopeIdFabricExtractorsRoute: typeof ClusterIdScopeIdFabricExtractorsRoute
  ClusterIdScopeIdFabricLifecycleRoute: typeof ClusterIdScopeIdFabricLifecycleRoute
  ClusterIdScopeIdFabricOverviewRoute: typeof ClusterIdScopeIdFabricOverviewRoute
  ClusterIdScopeIdFabricSearchRoute: typeof ClusterIdScopeIdFabricSearchRoute
  ClusterIdScopeIdFabricSourcesRoute: typeof ClusterIdScopeIdFabricSourcesRoute
  ClusterIdScopeIdFabricStorageRoute: typeof ClusterIdScopeIdFabricStorageRoute
  ClusterIdScopeIdFabricStreamsRoute: typeof ClusterIdScopeIdFabricStreamsRoute
  ClusterIdScopeIdFabricExtractorsExtractorIdRoute: typeof ClusterIdScopeIdFabricExtractorsExtractorIdRoute
  ClusterIdScopeIdFabricExtractorsNewRoute: typeof ClusterIdScopeIdFabricExtractorsNewRoute
}

const ClusterIdScopeIdFabricRouteChildren: ClusterIdScopeIdFabricRouteChildren =
  {
    ClusterIdScopeIdFabricDataModelRoute: ClusterIdScopeIdFabricDataModelRoute,
    ClusterIdScopeIdFabricExtractorsRoute:
      ClusterIdScopeIdFabricExtractorsRoute,
    ClusterIdScopeIdFabricLifecycleRoute: ClusterIdScopeIdFabricLifecycleRoute,
    ClusterIdScopeIdFabricOverviewRoute: ClusterIdScopeIdFabricOverviewRoute,
    ClusterIdScopeIdFabricSearchRoute: ClusterIdScopeIdFabricSearchRoute,
    ClusterIdScopeIdFabricSourcesRoute: ClusterIdScopeIdFabricSourcesRoute,
    ClusterIdScopeIdFabricStorageRoute: ClusterIdScopeIdFabricStorageRoute,
    ClusterIdScopeIdFabricStreamsRoute: ClusterIdScopeIdFabricStreamsRoute,
    ClusterIdScopeIdFabricExtractorsExtractorIdRoute:
      ClusterIdScopeIdFabricExtractorsExtractorIdRoute,
    ClusterIdScopeIdFabricExtractorsNewRoute:
      ClusterIdScopeIdFabricExtractorsNewRoute,
  }

const ClusterIdScopeIdFabricRouteWithChildren =
  ClusterIdScopeIdFabricRoute._addFileChildren(
    ClusterIdScopeIdFabricRouteChildren,
  )

interface ClusterIdScopeIdSettingsIntegrationsRouteChildren {
  ClusterIdScopeIdSettingsIntegrationsGovernanceRoute: typeof ClusterIdScopeIdSettingsIntegrationsGovernanceRoute
  ClusterIdScopeIdSettingsIntegrationsInstancesRoute: typeof ClusterIdScopeIdSettingsIntegrationsInstancesRoute
  ClusterIdScopeIdSettingsIntegrationsPluginsRoute: typeof ClusterIdScopeIdSettingsIntegrationsPluginsRoute
  ClusterIdScopeIdSettingsIntegrationsIndexRoute: typeof ClusterIdScopeIdSettingsIntegrationsIndexRoute
  ClusterIdScopeIdSettingsIntegrationsCatalogNameRoute: typeof ClusterIdScopeIdSettingsIntegrationsCatalogNameRoute
  ClusterIdScopeIdSettingsIntegrationsCatalogIndexRoute: typeof ClusterIdScopeIdSettingsIntegrationsCatalogIndexRoute
}

const ClusterIdScopeIdSettingsIntegrationsRouteChildren: ClusterIdScopeIdSettingsIntegrationsRouteChildren =
  {
    ClusterIdScopeIdSettingsIntegrationsGovernanceRoute:
      ClusterIdScopeIdSettingsIntegrationsGovernanceRoute,
    ClusterIdScopeIdSettingsIntegrationsInstancesRoute:
      ClusterIdScopeIdSettingsIntegrationsInstancesRoute,
    ClusterIdScopeIdSettingsIntegrationsPluginsRoute:
      ClusterIdScopeIdSettingsIntegrationsPluginsRoute,
    ClusterIdScopeIdSettingsIntegrationsIndexRoute:
      ClusterIdScopeIdSettingsIntegrationsIndexRoute,
    ClusterIdScopeIdSettingsIntegrationsCatalogNameRoute:
      ClusterIdScopeIdSettingsIntegrationsCatalogNameRoute,
    ClusterIdScopeIdSettingsIntegrationsCatalogIndexRoute:
      ClusterIdScopeIdSettingsIntegrationsCatalogIndexRoute,
  }

const ClusterIdScopeIdSettingsIntegrationsRouteWithChildren =
  ClusterIdScopeIdSettingsIntegrationsRoute._addFileChildren(
    ClusterIdScopeIdSettingsIntegrationsRouteChildren,
  )

interface ClusterIdScopeIdSettingsVantageRouteChildren {
  ClusterIdScopeIdSettingsVantageCasesRoute: typeof ClusterIdScopeIdSettingsVantageCasesRoute
  ClusterIdScopeIdSettingsVantageIndexRoute: typeof ClusterIdScopeIdSettingsVantageIndexRoute
}

const ClusterIdScopeIdSettingsVantageRouteChildren: ClusterIdScopeIdSettingsVantageRouteChildren =
  {
    ClusterIdScopeIdSettingsVantageCasesRoute:
      ClusterIdScopeIdSettingsVantageCasesRoute,
    ClusterIdScopeIdSettingsVantageIndexRoute:
      ClusterIdScopeIdSettingsVantageIndexRoute,
  }

const ClusterIdScopeIdSettingsVantageRouteWithChildren =
  ClusterIdScopeIdSettingsVantageRoute._addFileChildren(
    ClusterIdScopeIdSettingsVantageRouteChildren,
  )

interface ClusterIdScopeIdSettingsRouteChildren {
  ClusterIdScopeIdSettingsSplatRoute: typeof ClusterIdScopeIdSettingsSplatRoute
  ClusterIdScopeIdSettingsIntegrationsRoute: typeof ClusterIdScopeIdSettingsIntegrationsRouteWithChildren
  ClusterIdScopeIdSettingsOrganizationsRoute: typeof ClusterIdScopeIdSettingsOrganizationsRoute
  ClusterIdScopeIdSettingsTenantsRoute: typeof ClusterIdScopeIdSettingsTenantsRoute
  ClusterIdScopeIdSettingsTokensRoute: typeof ClusterIdScopeIdSettingsTokensRoute
  ClusterIdScopeIdSettingsUsersRoute: typeof ClusterIdScopeIdSettingsUsersRoute
  ClusterIdScopeIdSettingsVantageRoute: typeof ClusterIdScopeIdSettingsVantageRouteWithChildren
  ClusterIdScopeIdSettingsIndexRoute: typeof ClusterIdScopeIdSettingsIndexRoute
  ClusterIdScopeIdSettingsOrganizationsOrgIdRoute: typeof ClusterIdScopeIdSettingsOrganizationsOrgIdRoute
  ClusterIdScopeIdSettingsTenantsTenantIdRoute: typeof ClusterIdScopeIdSettingsTenantsTenantIdRoute
}

const ClusterIdScopeIdSettingsRouteChildren: ClusterIdScopeIdSettingsRouteChildren =
  {
    ClusterIdScopeIdSettingsSplatRoute: ClusterIdScopeIdSettingsSplatRoute,
    ClusterIdScopeIdSettingsIntegrationsRoute:
      ClusterIdScopeIdSettingsIntegrationsRouteWithChildren,
    ClusterIdScopeIdSettingsOrganizationsRoute:
      ClusterIdScopeIdSettingsOrganizationsRoute,
    ClusterIdScopeIdSettingsTenantsRoute: ClusterIdScopeIdSettingsTenantsRoute,
    ClusterIdScopeIdSettingsTokensRoute: ClusterIdScopeIdSettingsTokensRoute,
    ClusterIdScopeIdSettingsUsersRoute: ClusterIdScopeIdSettingsUsersRoute,
    ClusterIdScopeIdSettingsVantageRoute:
      ClusterIdScopeIdSettingsVantageRouteWithChildren,
    ClusterIdScopeIdSettingsIndexRoute: ClusterIdScopeIdSettingsIndexRoute,
    ClusterIdScopeIdSettingsOrganizationsOrgIdRoute:
      ClusterIdScopeIdSettingsOrganizationsOrgIdRoute,
    ClusterIdScopeIdSettingsTenantsTenantIdRoute:
      ClusterIdScopeIdSettingsTenantsTenantIdRoute,
  }

const ClusterIdScopeIdSettingsRouteWithChildren =
  ClusterIdScopeIdSettingsRoute._addFileChildren(
    ClusterIdScopeIdSettingsRouteChildren,
  )

interface ClusterIdScopeIdVantageRouteChildren {
  ClusterIdScopeIdVantageCasesRoute: typeof ClusterIdScopeIdVantageCasesRoute
  ClusterIdScopeIdVantageCoverageRoute: typeof ClusterIdScopeIdVantageCoverageRoute
  ClusterIdScopeIdVantageDetectionsRoute: typeof ClusterIdScopeIdVantageDetectionsRoute
  ClusterIdScopeIdVantageOverviewRoute: typeof ClusterIdScopeIdVantageOverviewRoute
  ClusterIdScopeIdVantageSignalsRoute: typeof ClusterIdScopeIdVantageSignalsRoute
  ClusterIdScopeIdVantageCasesCaseIdRoute: typeof ClusterIdScopeIdVantageCasesCaseIdRoute
  ClusterIdScopeIdVantageDetectionsWorkbookRoute: typeof ClusterIdScopeIdVantageDetectionsWorkbookRoute
}

const ClusterIdScopeIdVantageRouteChildren: ClusterIdScopeIdVantageRouteChildren =
  {
    ClusterIdScopeIdVantageCasesRoute: ClusterIdScopeIdVantageCasesRoute,
    ClusterIdScopeIdVantageCoverageRoute: ClusterIdScopeIdVantageCoverageRoute,
    ClusterIdScopeIdVantageDetectionsRoute:
      ClusterIdScopeIdVantageDetectionsRoute,
    ClusterIdScopeIdVantageOverviewRoute: ClusterIdScopeIdVantageOverviewRoute,
    ClusterIdScopeIdVantageSignalsRoute: ClusterIdScopeIdVantageSignalsRoute,
    ClusterIdScopeIdVantageCasesCaseIdRoute:
      ClusterIdScopeIdVantageCasesCaseIdRoute,
    ClusterIdScopeIdVantageDetectionsWorkbookRoute:
      ClusterIdScopeIdVantageDetectionsWorkbookRoute,
  }

const ClusterIdScopeIdVantageRouteWithChildren =
  ClusterIdScopeIdVantageRoute._addFileChildren(
    ClusterIdScopeIdVantageRouteChildren,
  )

interface ClusterIdScopeIdRouteRouteChildren {
  ClusterIdScopeIdSplatRoute: typeof ClusterIdScopeIdSplatRoute
  ClusterIdScopeIdFabricRoute: typeof ClusterIdScopeIdFabricRouteWithChildren
  ClusterIdScopeIdHomeRoute: typeof ClusterIdScopeIdHomeRoute
  ClusterIdScopeIdSettingsRoute: typeof ClusterIdScopeIdSettingsRouteWithChildren
  ClusterIdScopeIdVantageRoute: typeof ClusterIdScopeIdVantageRouteWithChildren
}

const ClusterIdScopeIdRouteRouteChildren: ClusterIdScopeIdRouteRouteChildren = {
  ClusterIdScopeIdSplatRoute: ClusterIdScopeIdSplatRoute,
  ClusterIdScopeIdFabricRoute: ClusterIdScopeIdFabricRouteWithChildren,
  ClusterIdScopeIdHomeRoute: ClusterIdScopeIdHomeRoute,
  ClusterIdScopeIdSettingsRoute: ClusterIdScopeIdSettingsRouteWithChildren,
  ClusterIdScopeIdVantageRoute: ClusterIdScopeIdVantageRouteWithChildren,
}

const ClusterIdScopeIdRouteRouteWithChildren =
  ClusterIdScopeIdRouteRoute._addFileChildren(
    ClusterIdScopeIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClusterIdScopeIdRouteRoute: ClusterIdScopeIdRouteRouteWithChildren,
  ClusterIdSplatRoute: ClusterIdSplatRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthHandoffTokenRoute: AuthHandoffTokenRoute,
  AuthHandoffIndexRoute: AuthHandoffIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
